import { createSlice } from "@reduxjs/toolkit";

/** The new PDP's Submit a Question modal lives in Q&A, but Reviews can open it too. */
export interface AskQuestionModalSliceState {
  open: boolean;
}

const initialState: AskQuestionModalSliceState = {
  open: false,
};

export const askQuestionModalSlice = createSlice({
  name: "askQuestionModalSlice",
  initialState,
  reducers: {
    openAskQuestionModal: (state) => {
      state.open = true;
    },
    closeAskQuestionModal: (state) => {
      state.open = false;
    },
  },
});

export const { openAskQuestionModal, closeAskQuestionModal } = askQuestionModalSlice.actions;
export default askQuestionModalSlice;
